/* ==========================================================================
   Solzaleben, vloeren-PDP: eigen knoppen voor Bid & Buy (app solza-bid).

   De app blijft ongewijzigd. Zijn app block staat (onzichtbaar) in de
   koopsectie en beslist zelf of bieden mag: het zet [data-solza-bid-block]
   pas zichtbaar (hidden weg) als de app-proxy "visible" antwoordt.

   - [data-solza-bid-trigger-wrap] blijft verborgen tot het block zichtbaar is;
     wordt het weer verborgen, dan verdwijnen onze knoppen ook.
   - [data-solza-bid-open] opent het bodvenster van de app: via
     window.SolzaBidBlock.open(block) als die al bestaat, anders met een klik
     op de eigen knop van het block (die laadt het modal-script pas bij de
     eerste interactie). Er wordt niets vooraf ingevuld.
   - GA4-event bid_open bij elke klik (gtag, anders dataLayer), met de getoonde
     Ansprechpartner als parameter contact.
   - Ansprechpartner per bezoek: de koopsectie rendert de eerste actieve persoon
     en een <template> per actieve persoon. Bij het eerste paginabezoek kiezen
     we willekeurig een persoon en bewaren die in sessionStorage; daarna overal
     dezelfde tot het tabblad sluit. Werkt sessionStorage niet: per pagina
     willekeurig. We wisselen alleen foto, naam en alt-tekst.

   Ontbreekt de app of faalt er iets, dan blijven de knoppen verborgen en
   komt er niets in de console.
   ========================================================================== */
(function () {
  'use strict';

  if (window.SolzaPdpBid) return; // script kan door twee secties geladen worden
  window.SolzaPdpBid = true;

  function zoekBlock() {
    return document.querySelector('[data-solza-bid-block]');
  }

  function toonKnoppen(zichtbaar) {
    document.querySelectorAll('[data-solza-bid-trigger-wrap]').forEach(function (wrap) {
      wrap.hidden = !zichtbaar;
    });
  }

  /* ------------------------------------------------------- Ansprechpartner */
  var OPSLAG = 'solza-bid-contact';
  var contact = '';

  function kiesContact() {
    var sjablonen = Array.prototype.slice.call(document.querySelectorAll('template[data-solza-contact]'));
    if (!sjablonen.length) return null;
    var sleutels = sjablonen.map(function (t) { return t.getAttribute('data-solza-contact'); });
    var gekozen = null;
    try {
      gekozen = window.sessionStorage.getItem(OPSLAG);
    } catch (_fout) {
      gekozen = null;
    }
    if (sleutels.indexOf(gekozen) === -1) {
      gekozen = sleutels[Math.floor(Math.random() * sleutels.length)];
      try {
        window.sessionStorage.setItem(OPSLAG, gekozen);
      } catch (_fout) {
        /* geen opslag: volgende pagina kiest opnieuw */
      }
    }
    return sjablonen[sleutels.indexOf(gekozen)];
  }

  function toonContact() {
    var sjabloon = kiesContact();
    if (!sjabloon) return;
    contact = sjabloon.getAttribute('data-solza-contact');
    var naam = sjabloon.getAttribute('data-naam');
    var fotos = sjabloon.content.querySelectorAll('img');
    try {
      // De cart drawer (solza-cart.js) toont dezelfde naam, ook buiten de PDP.
      window.sessionStorage.setItem(OPSLAG + '-naam', naam);
    } catch (_fout) {
      /* geen opslag: de drawer zegt "uns" */
    }

    document.querySelectorAll('[data-solza-contact-slot]').forEach(function (slot) {
      var foto = slot.getAttribute('data-solza-contact-slot') === 'band' ? fotos[1] : fotos[0];
      var oud = slot.querySelector('img');
      if (foto) {
        var nieuw = foto.cloneNode(true);
        if (oud) oud.replaceWith(nieuw);
        else slot.insertBefore(nieuw, slot.firstChild);
      }
      slot.querySelectorAll('[data-solza-contact-naam]').forEach(function (el) {
        el.textContent = naam;
      });
      slot.hidden = false;
    });
  }

  function meet(knop, block) {
    var params = {
      location: knop.getAttribute('data-solza-bid-open') || 'unbekannt',
      product_id: (block && block.getAttribute('data-product-id')) || '',
      contact: contact,
    };
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'bid_open', params);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: 'bid_open' }, params));
      }
    } catch (_fout) {
      /* meten mag het openen nooit blokkeren */
    }
  }

  // De app zet de focus na het sluiten terug op zijn eigen (verborgen) knop;
  // die kan geen focus krijgen, dus belandt de focus op <body>. Wij zetten hem
  // terug op de knop waarmee de klant het venster opende.
  var laatsteKnop = null;
  var venster = null;

  function bewaakSluiten() {
    if (venster) return;
    var pogingen = 0;
    var timer = setInterval(function () {
      pogingen += 1;
      var form = document.querySelector('form.solza-bid-modal');
      if (form || pogingen > 50) clearInterval(timer);
      if (!form) return;
      venster = form;
      new MutationObserver(function () {
        if (!form.hidden || !laatsteKnop) return;
        var actief = document.activeElement;
        if (!actief || actief === document.body || !actief.offsetParent) laatsteKnop.focus();
      }).observe(form, { attributes: true, attributeFilter: ['hidden'] });
    }, 100);
  }

  function open(knop) {
    var block = zoekBlock();
    if (!block || block.hidden) return;
    meet(knop, block);
    laatsteKnop = knop;
    bewaakSluiten();

    try {
      var api = window.SolzaBidBlock;
      if (api && typeof api.open === 'function') {
        api.open(block);
        return;
      }
      var launcher = block.querySelector('[data-solza-open-modal]');
      if (launcher) launcher.click();
    } catch (_fout) {
      /* app faalt: niets doen, de pagina blijft bruikbaar */
    }
  }

  function init() {
    try {
      toonContact();
    } catch (_fout) {
      /* server-versie (eerste persoon) blijft staan */
    }

    var block = zoekBlock();
    if (!block) return; // geen app: knoppen blijven verborgen

    document.addEventListener('click', function (event) {
      var knop = event.target.closest && event.target.closest('[data-solza-bid-open]');
      if (!knop) return;
      event.preventDefault();
      open(knop);
    });

    // Vanuit de cart drawer op een andere pagina: PDP-url met #bieden opent de
    // popup zodra de app bieden toestaat (GA4 location "cart").
    var vanuitCart = window.location.hash === '#bieden';
    function misschienOpenen() {
      if (!vanuitCart || block.hidden) return;
      vanuitCart = false;
      var koopKnop = document.querySelector('[data-solza-bid-open="koopbox"]');
      open({
        getAttribute: function () {
          return 'cart';
        },
        focus: function () {
          if (koopKnop) koopKnop.focus();
        },
      });
    }

    toonKnoppen(!block.hidden);
    misschienOpenen();
    new MutationObserver(function () {
      toonKnoppen(!block.hidden);
      misschienOpenen();
    }).observe(block, { attributes: true, attributeFilter: ['hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
